import React from "react";
import {TaggedLogger} from "@nextlot/core/utilities";
import NetworkDisconnectedAlertPanelOverlayCmp from "../NetworkDisconnectedAlertPanelOverlayCmp";
import {WebcastStateEnum} from "@nextlot/core/webcast";
import useWebcastConnect from "@nextlot/core/webcast/hooks/useWebcastConnect";
import EmbeddedViewerHeaderCmp from "./ViewerEmbeddedHeaderCmp";
import EmbeddedViewerMediaStreamingRootCmp from "./ViewerEmbeddedMediaStreamingRootCmp"
import EmbeddedViewerCurrentRoundLotsCmp from "./ViewerEmbeddedCurrentRoundLotsCmp";
import {DataStore} from "@nextlot/core/webcast";
import {useTranslation} from "react-i18next";


const _logger = TaggedLogger.get('EmbeddedViewerRootCmp');

export default function ViewerEmbeddedRootCmp(props) {
    _logger.debug('.render()', props);

    const webcastStatusState = useWebcastConnect();
    const { t, i18n } = useTranslation();


    return (
        <>
            <NetworkDisconnectedAlertPanelOverlayCmp/>

            {

                (webcastStatusState === WebcastStateEnum.WEBCAST_STATE__CLOSED)
                    ? <div className="w-100 h-100 d-flex justify-content-center align-items-center"><h3>{t('webcastFinished')}</h3></div>
                    : (webcastStatusState > WebcastStateEnum.WEBCAST_STATE__LOADING)
                        ? <LoadedAppStateViewCmp />
                        : <div className="w-100 h-100 d-flex justify-content-center align-items-center">
                            <h3>Loading, please wait ...</h3>
                        </div>


            }

        </>)
}

function LoadedAppStateViewCmp(props) {

    return (
        <>
            <div className="viewer-embedded-iframe-container">

                <EmbeddedViewerHeaderCmp/>

                <div className="d-flex justify-content-around w-100 flex-wrap">
                    <div className="d-flex flex-column justify-content-between viewer-embedded-media-container mt-2">
                        <EmbeddedViewerMediaStreamingRootCmp/>

                        <a href={DataStore.config.site_domain} target='_blank' rel="noopener noreferrer" className="mt-3 p-3 btn btn-lg btn-block btn-register-to-bid">Register to Bid on Lyon Auction Live</a>
                    </div>

                    {/*<div className="vertical-spacer"/>*/}

                    <div className="d-flex flex-column viewer-embedded-currend-round-container mt-2">
                        <EmbeddedViewerCurrentRoundLotsCmp/>
                    </div>
                </div>
            </div>
        </>
    )
}


// import * as React from "react";
// import {connect} from "react-redux";
// import {compose} from "redux";
// import {TaggedLogger} from "@nextlot/bidding-jsclient-core/lib/util";
// import {WebcastStateEnum} from "@nextlot/bidding-jsclient-core/lib/data/WebcastDataDomain";
// import AuctionsManager from "@nextlot/bidding-jsclient-core/lib/services/AuctionsManager";
// import type {ReduxActiveWebcastSubStateType} from "@nextlot/bidding-jsclient-core/lib/redux/reducerActiveWebcast";
// import NetworkDisconnectedAlertPanelOverlayCmp from "../NetworkDisconnectedAlertPanelOverlayCmp";
// import {withTranslation} from 'react-i18next';
// import EmbeddedViewerHeaderCmp from "./ViewerEmbeddedHeaderCmp";
// import EmbeddedViewerMediaStreamingRootCmp from "./ViewerEmbeddedMediaStreamingRootCmp"
// import EmbeddedViewerCurrentRoundLotsCmp from "./ViewerEmbeddedCurrentRoundLotsCmp";
// import DataStore from "@nextlot/bidding-jsclient-core/lib/services/DataStore";
//
//
// type RootCmpPropsType = {
//     webcastStatusState: number,
// };
//
// type RootCmpStateType = {
//     connectInProgress: boolean,
// };
//
//
// const _logger = TaggedLogger.get('EmbeddedViewerRootCmp');
//
//
// class ViewerEmbeddedRootCmp extends React.PureComponent<RootCmpPropsType, RootCmpStateType> {
//
//
//     constructor(props) {
//         super(props);
//         _logger.debug('.constructor()', props);
//
//         this.state = {
//             connectInProgress: true,
//         }
//     }
//
//
//     componentDidMount(): void {
//         _logger.debug('.componentDidMount()');
//
//         this.setState({
//             connectInProgress: true
//         });
//
//         AuctionsManager.currentWebcastAuctionHandler.connect()
//             .then(() => {
//                 console.log('.componentDidMount()>currentWebcastSaleHandler.connect().then()');
//                 this.setState({
//                     connectInProgress: false
//                 });
//             })
//             .catch((reason) => {
//                 console.error('.componentDidMount()>currentWebcastSaleHandler.connect().catch()', reason, reason.stack);
//                 this.setState({
//                     connectInProgress: false
//                 });
//             });
//     }
//
//
//     _renderAppLoadingState() {
//         return (
//             <div className="w-100 h-100 d-flex justify-content-center align-items-center">
//                 <h3>Loading, please wait ...</h3>
//             </div>
//         )
//     }
//
//
//     _renderLoadedAppState() {
//         return (
//             <div className="viewer-embedded-iframe-container">
//
//                 <EmbeddedViewerHeaderCmp/>
//
//                 <div className="d-flex justify-content-around w-100 flex-wrap">
//                     <div className="d-flex flex-column justify-content-between viewer-embedded-media-container mt-2">
//                         <EmbeddedViewerMediaStreamingRootCmp/>
//
//                         <a href={DataStore.config.siteRegisterUrl} target='_blank' rel="noopener noreferrer" className="mt-3 p-3 btn btn-lg btn-block btn-register-to-bid">
//                             Register to Bid
//                         </a>
//                     </div>
//
//                     <div className="vertical-spacer"/>
//
//                     <div className="d-flex flex-column viewer-embedded-currend-round-container mt-2">
//                         <EmbeddedViewerCurrentRoundLotsCmp/>
//                     </div>
//                 </div>
//             </div>
//         )
//     }
//
//
//     _renderEventClosedAppState() {
//         return (
//             <div className="w-100 h-100 d-flex justify-content-center align-items-center">
//                 <h3>The webcast event has closed. Thank you.</h3>
//             </div>
//         )
//     }
//
//
//     _renderAppState() {
//         if (this.props.webcastStatusState === WebcastStateEnum.WEBCAST_STATE__CLOSED) {
//             return this._renderEventClosedAppState();
//         }
//
//         if (this.props.webcastStatusState > WebcastStateEnum.WEBCAST_STATE__LOADING) {
//             return this._renderLoadedAppState();
//         }
//
//         return this._renderAppLoadingState();
//     }
//
//     render() {
//         return <React.Fragment>
//             <NetworkDisconnectedAlertPanelOverlayCmp
//                 connectInProgress={this.state.connectInProgress}
//             />
//
//             {this._renderAppState()}
//
//         </React.Fragment>
//     }
// }
//
// export default compose(
//     connect(({activeWebcast}: { activeWebcast: ReduxActiveWebcastSubStateType }) => {
//         return {
//             webcastStatusState: activeWebcast.webcastStatus.state,
//         }
//     }),
//     withTranslation()
// )(ViewerEmbeddedRootCmp)
//
